import React, {useState, useRef} from 'react';
import useOutsideClick from '@ibibo/use-outside-click';

import * as S from './SelectBox.styles';

const SelectBox = ({placeholder, options, onChange, width, errorMsg, isError, value}) => {
  const optionRef = useRef();

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');

  const handleClick = () => {
    setIsOpen(true);
  };

  const handleSelect = itm => {
    setSelected(itm.text);
    setIsOpen(false);
    onChange(itm?.text);
  };

  useOutsideClick(optionRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <S.SlctBox width={width}>
      <S.SlctBoxWrap onClick={handleClick} active={isOpen} isError={isError}>
        {placeholder && <label>{selected && value ? selected : placeholder}</label>}
      </S.SlctBoxWrap>
      {options && options.length > 0 && isOpen && (
        <S.SlctBoxContent ref={optionRef}>
          <S.OptionList>
            {options.map(item => (
              <S.OptionListItem key={item.id} onClick={() => handleSelect(item)}>
                {item.text}
              </S.OptionListItem>
            ))}
          </S.OptionList>
        </S.SlctBoxContent>
      )}
      {errorMsg && <S.ErrMsg>{errorMsg}</S.ErrMsg>}
    </S.SlctBox>
  );
};

export default SelectBox;
